module.exports = __webpack_public_path__ + "img/Type_Electric.3a5494b4.png";